module.exports = __webpack_public_path__ + "static/qh_5.16c197bb.jpg";